import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgProfileSelectedNavIconSecondary from './svgs/ProfileSelectedNavIconSecondary.js';
import SvgProfileSelectedNavIcon from './svgs/ProfileSelectedNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var profileSelectedNavIcon = (props => useIcon(SvgProfileSelectedNavIcon, SvgProfileSelectedNavIconSecondary, props));

export { profileSelectedNavIcon as default };
